import type { filter } from 'utility'
import type { ManualReviewRow } from './manualReview'
import { getPurchaseUrl } from './specialStores'

export type ExecutableSearch = { url: string, reason: string, notes: string }
export const matchesSearch = (value: string | null | undefined, term: string): boolean =>
  (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(term.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase())

// Filter the full eligible set before server pagination, never just visible rows.
// Text stays outside the legacy query builder; only numeric IDs reach it.
export async function executableSearchFilters (client: any, ids: number[], queue: ManualReviewRow[], search: ExecutableSearch): Promise<filter[]> {
  if (!Object.values(search).some(term => term.trim())) return []
  let matches = ids
  if (search.reason.trim()) {
    const reasonIds = new Set(queue.filter(row => matchesSearch(`${row.reason} ${row.affected_item_ids.join(' ')}`, search.reason)).map(row => row.order_id))
    matches = matches.filter(id => reasonIds.has(id))
  }
  if (search.url.trim() || search.notes.trim()) {
    const found: number[] = []
    const projection = ['id', ...(search.notes.trim() ? ['comments'] : []), ...(search.url.trim() ? ['marketplace_id(id, original_url)', 'items(url, custom_order_site, deleted)'] : [])].join(', ')
    for (let offset = 0; offset < matches.length; offset += 200) {
      const { data, error } = await client.from('orders').select(projection).in('id', matches.slice(offset, offset + 200))
      if (error || !Array.isArray(data)) throw new Error('No se pudo aplicar la búsqueda de pedidos')
      for (const row of data) {
        if (matchesSearch(getPurchaseUrl(row), search.url) && matchesSearch(row.comments, search.notes)) found.push(row.id)
      }
    }
    matches = found
  }
  return [{ field: 'id', operator: 'in', value: matches.length ? matches : [-1] }]
}
